const semanticClassNames = {
  root: 'video-upload',
  title: 'video-upload__title',
} as const;

export default semanticClassNames;
